(function () {
  function syncCheckboxFromRadios(fieldset) {
    var checkbox = fieldset.querySelector('.ab-checkbox-toggle');
    var withRadio = fieldset.querySelector('[data-ab-role="with"]');
    if (!checkbox || !withRadio) return;
    checkbox.checked = withRadio.checked;
  }

  function selectAbRadio(fieldset, role) {
    var radio = fieldset.querySelector('[data-ab-role="' + role + '"]');
    if (!radio || radio.disabled || radio.classList.contains('disabled')) return;
    if (radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getAbCheckboxFieldset(el) {
    if (!el || !el.closest) return null;
    return el.closest('[data-ab-checkbox]') || el.closest('.product-form__input--ab-checkbox');
  }

  function initAbCheckboxFieldset(fieldset) {
    if (!fieldset) return;

    if (fieldset.dataset.abInitialized !== 'true') {
      fieldset.dataset.abInitialized = 'true';

      var checkbox = fieldset.querySelector('.ab-checkbox-toggle');

      syncCheckboxFromRadios(fieldset);

      if (checkbox) {
        checkbox.addEventListener('change', function () {
          selectAbRadio(fieldset, checkbox.checked ? 'with' : 'without');
        });
      }

      fieldset.querySelectorAll('.ab-option-radio').forEach(function (radio) {
        radio.addEventListener('change', function () {
          syncCheckboxFromRadios(fieldset);
        });
      });
    }

    var infoWrap = fieldset.querySelector('.ab-checkbox-info-wrap');
    var infoBtn = fieldset.querySelector('.ab-checkbox-info');
    var tooltip = fieldset.querySelector('.ab-checkbox-tooltip');
    var hideTimer = null;

    if (!infoWrap || !infoBtn || !tooltip || infoBtn.dataset.abInfoInitialized === 'true') return;
    infoBtn.dataset.abInfoInitialized = 'true';

    var showTooltip = function () {
      window.clearTimeout(hideTimer);
      tooltip.removeAttribute('hidden');
      tooltip.classList.add('is-visible');
      infoWrap.classList.add('is-tooltip-open');
      infoBtn.setAttribute('aria-expanded', 'true');
    };

    var hideTooltip = function () {
      tooltip.classList.remove('is-visible');
      infoWrap.classList.remove('is-tooltip-open');
      infoBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        if (!tooltip.classList.contains('is-visible')) {
          tooltip.setAttribute('hidden', '');
        }
      }, 200);
    };

    var scheduleHide = function () {
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(hideTooltip, 120);
    };

    infoWrap.addEventListener('mouseenter', showTooltip);
    infoWrap.addEventListener('mouseleave', scheduleHide);
    infoWrap.addEventListener('focusin', showTooltip);
    infoWrap.addEventListener('focusout', function (event) {
      if (!infoWrap.contains(event.relatedTarget)) {
        scheduleHide();
      }
    });

    infoBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (tooltip.classList.contains('is-visible')) {
        hideTooltip();
      } else {
        showTooltip();
      }
    });

    document.addEventListener('click', function (event) {
      if (!infoWrap.contains(event.target)) {
        hideTooltip();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        hideTooltip();
      }
    });
  }

  function initAllAbCheckboxes(root) {
    var scope = root || document;
    var fieldsets = new Set();

    scope.querySelectorAll('[data-ab-checkbox], .product-form__input--ab-checkbox').forEach(function (fieldset) {
      fieldsets.add(fieldset);
    });

    scope.querySelectorAll('.ab-checkbox-info').forEach(function (infoBtn) {
      var fieldset = getAbCheckboxFieldset(infoBtn);
      if (fieldset) fieldsets.add(fieldset);
    });

    fieldsets.forEach(initAbCheckboxFieldset);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllAbCheckboxes();
  });

  document.addEventListener('product-info:loaded', function () {
    initAllAbCheckboxes();
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches) {
          if (node.matches('[data-ab-checkbox], .product-form__input--ab-checkbox')) {
            initAbCheckboxFieldset(node);
          } else if (node.matches('.ab-checkbox-info')) {
            initAbCheckboxFieldset(getAbCheckboxFieldset(node));
          }
        }
        initAllAbCheckboxes(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
